import React from 'react';
import * as constantClass from '../fileWithConstants';
import { createPagedGridController } from '../../hooks/pagedGridClassAdapter';
import * as carrerasService from '../../services/carreras/carrerasService';
import { classifyCarrerasError } from '../../services/carreras/carrerasDto';
import { LookupModal, LookupSelectButton, LookupActionHeader } from '../common/LookupModal';
import { createLookupSearchHandlers } from '../common/lookupGridSearch';

export class LookupCarreras extends React.Component {
  constructor(props) {
    super(props);
    this.searchInputRef = React.createRef();
    this.state = {
      show: true,
      loading: true,
      searchInput: '',
      perPage: 5,
      paginationData: [],
      pageCount: 1,
      forcePage: 0,
      showErrorMessage: false,
      errorMessage: '',
    };
    this.grid = createPagedGridController({
      fetchPage: (query) => carrerasService.lookupCarreras(query),
      defaultPageSize: 5,
      onChange: (gridState) => this.applyGridState(gridState),
    });
    const searchHandlers = createLookupSearchHandlers(
      this,
      this.grid,
      (error) => this.handleCarrerasError(error)
    );
    this.handleSearchInputChange = searchHandlers.handleSearchInputChange;
    this.handleSearchSubmit = searchHandlers.handleSearchSubmit;
  }

  handleModal() {
    this.setState({ show: !this.state.show });
    this.props.hideLookup();
  }

  async componentDidMount() {
    const canAccess = await constantClass.canAccess('WWCarreras');
    if (canAccess) {
      this.populateData();
    }
  }

  applyGridState(gridState) {
    this.setState({
      paginationData: gridState.items,
      pageCount: gridState.pageCount,
      searchInput: gridState.search,
      perPage: gridState.pageSize,
      loading: gridState.loading,
      forcePage: gridState.forcePage,
      showErrorMessage: Boolean(gridState.error),
      errorMessage: gridState.error?.message ?? '',
    });
  }

  handlePageClick = (e) => {
    this.grid.handlePageClick(e).catch((error) => this.handleCarrerasError(error));
  };

  handleItemSelect = (e) => {
    this.props.selectItem(e);
    this.setState({ show: false });
  };

  renderTable(carreras) {
    return (
      <table className="md-lookup__table" aria-label="Seleccionar la Carrera">
        <thead>
          <tr>
            <th scope="col" className="md-lookup__col-code">Código</th>
            <th scope="col">Nombre</th>
            <LookupActionHeader />
          </tr>
        </thead>
        <tbody>
          {carreras.map((carrera) => (
            <tr key={carrera.carreraCod}>
              <td className="md-lookup__col-code">{carrera.carreraCod}</td>
              <td>{carrera.carreraNombre}</td>
              <LookupSelectButton
                testId="pick-carrera-lookup"
                onClick={() => this.handleItemSelect(`${carrera.carreraCod}%${carrera.carreraNombre}`)}
              />
            </tr>
          ))}
        </tbody>
      </table>
    );
  }

  render() {
    return (
      <LookupModal
        show={this.state.show}
        onHide={() => this.handleModal()}
        title="Seleccionar la Carrera"
        searchInputRef={this.searchInputRef}
        searchInput={this.state.searchInput}
        searchPlaceholder="Ingrese Nombre de la Carrera"
        onSearchInputChange={this.handleSearchInputChange}
        onSearchSubmit={this.handleSearchSubmit}
        loading={this.state.loading}
        errorMessage={this.state.showErrorMessage ? this.state.errorMessage : ''}
        pageCount={this.state.pageCount}
        forcePage={this.state.forcePage}
        onPageChange={this.handlePageClick}
      >
        {this.renderTable(this.state.paginationData)}
      </LookupModal>
    );
  }

  handleCarrerasError(error) {
    const outcome = classifyCarrerasError(error);
    if (outcome.type === 'timeout') {
      constantClass.RedirectToLogin();
      return;
    }
    this.setState({
      showErrorMessage: true,
      errorMessage: outcome.message,
      loading: false,
    });
  }

  async populateData() {
    try {
      await this.grid.load();
    } catch (error) {
      this.handleCarrerasError(error);
    }
  }
}
